export default "__VITE_ASSET__BH_6uhut__"